import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	unknownErrorOccurred: {
		id: `eoc.heartbeats.name-input.unknown-error-occurred.no-translate`,
		defaultMessage: 'An unknown error occurred',
		description: `The text will be displayed if an unknown error occurs`,
	},
});

export default messages;
